import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-plus', 'IconClockPlus', [
  ['path', { d: 'M20.984 12.535a9 9 0 1 0 -8.468 8.45', key: 'svg-0' }],
  ['path', { d: 'M16 19h6', key: 'svg-1' }],
  ['path', { d: 'M19 16v6', key: 'svg-2' }],
  ['path', { d: 'M12 7v5l3 3', key: 'svg-3' }],
]);
